import _ from 'lodash';
import { compareIgnoreCase, containsIgnoreCase } from '@ane/core/lib/utils/CommonStringUtils';
import { BING_EXPANDED_FEATURE_LINK } from '../../../../utils/flight.constants';
export const buildCompositionInfo = (workspaceId, managementGroup, compositionResult) => {
    const isFeatureComp = isFeatureComposition(compositionResult);
    const rotatingParentFlights = isFeatureComp ? getRotatingParentFlights(compositionResult) : [];
    const workingCompositions = isFeatureComp ? getWorkingCompositions(compositionResult, workspaceId, managementGroup) : [];
    return {
        isFeatureComposition: isFeatureComp,
        name: compositionResult.SelectedFlight,
        compositionGraph: compositionResult,
        rotatingParentFlights: rotatingParentFlights,
        workingCompositions: workingCompositions,
        managementGroup: managementGroup,
    };
};
export const isFeatureComposition = (compositionResult) => {
    return (!!compositionResult.Nodes &&
        _.some(compositionResult.Nodes, (node) => !compareIgnoreCase(node.FlightName, compositionResult.SelectedFlight)));
};
export const getRotatingParentFlights = (composition) => {
    var flightName = composition.SelectedFlight;
    const runningFlights = _.filter(composition.Nodes, (node) => {
        return (containsIgnoreCase((node.CompositionChildren || []).map((n) => n.FlightName), flightName) && node.IsRunning);
    });
    return _.map(runningFlights, (flight) => flight.FlightName);
};
export const getWorkingCompositions = (composition, workspaceId, managementGroup) => {
    var _a;
    const flight = _.find(composition.Nodes, (node) => compareIgnoreCase(node.FlightName, composition.SelectedFlight));
    if (!flight || !((_a = flight.CompositionChildren) === null || _a === void 0 ? void 0 : _a.length)) {
        return [];
    }
    const childrenFlightNames = _.map(flight.CompositionChildren, (n) => n.FlightName);
    const matchingCompositions = _.filter(composition.Nodes, (n) => containsIgnoreCase(childrenFlightNames, n.FlightName));
    return _.map(matchingCompositions, (n) => {
        var _a, _b, _c;
        return {
            name: n.FlightName,
            isRunning: n.IsRunning,
            numOfParents: n.NumberOfParents,
            numOfChidren: ((_a = n.CompositionChildren) === null || _a === void 0 ? void 0 : _a.length) || 0,
            isolationGroups: n.IsolationGroups || [],
            forceAssignOnNumberline: (_c = (_b = _.find(flight.CompositionChildren, (f) => compareIgnoreCase(f.FlightName, n.FlightName))) === null || _b === void 0 ? void 0 : _b.ForceAssignOnNumberline) !== null && _c !== void 0 ? _c : false,
            workspaceId: workspaceId,
            managementGroup: managementGroup,
        };
    });
};
export const getExpandedLivesiteLink = (composition) => {
    var _a;
    const expandedFlights = [];
    const nodeDict = _.keyBy(composition.compositionGraph.Nodes, (n) => n.FlightName);
    // Only expand downstream flights
    const descendants = [composition.compositionGraph.SelectedFlight];
    const visited = {};
    while (descendants.length > 0) {
        const flightName = descendants.shift();
        if (flightName) {
            expandedFlights.push(flightName);
            _.forEach((_a = nodeDict[flightName]) === null || _a === void 0 ? void 0 : _a.CompositionChildren, (c) => {
                if (!visited[c.FlightName]) {
                    visited[c.FlightName] = true;
                    descendants.push(c.FlightName);
                }
            });
        }
    }
    return `${BING_EXPANDED_FEATURE_LINK}${expandedFlights === null || expandedFlights === void 0 ? void 0 : expandedFlights.join(',')}`;
};

//# sourceMappingURL=Composition.utils.js.map
